import { z } from "zod"

export const ProductClassificationSchema = z.object({
  category: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .refine((value) => value.id.trim() !== "" || value.label.trim() !== "", { message: "Category name is required." }),
  name: z
    .string()
    .trim()
    .min(2, { message: "Product Class name must be at least 2 characters." })
    .max(25, { message: "Product Class name must not exceed 25 characters." })
    .regex(/^[a-zA-Z0-9&.,'\-()[\]/! ]*$/, {
      message:
        "Product Class name can only contain letters, numbers, spaces, and these special characters: . , ' - ( ) [ ] & ! /",
    }),
  productManager: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .refine((value) => value.id.trim() !== "" || value.label.trim() !== "", {
      message: "Product Manager name is required.",
    }),
})

export type ProductClassificationFormValues = z.infer<typeof ProductClassificationSchema>
export type ProductManagerFormValue = ProductClassificationFormValues["productManager"]
export type ProductCategoryFormValue = ProductClassificationFormValues["category"]
